import React, { useEffect, useState } from "react";

export default function DetailSection() {
  const [latestInfo, setLatestInfo] = useState([]);
  const [specialAchievements, setSpecialAchievements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([
      fetch("/api/home/latest-info")
        .then(r => {
          if (!r.ok) throw new Error("Failed to fetch latest info");
          return r.json();
        }),
      fetch("/api/home/special-achievements")
        .then(r => {
          if (!r.ok) throw new Error("Failed to fetch special achievements");
          return r.json();
        }),
    ])
      .then(([infoData, specialData]) => {
        setLatestInfo(infoData);
        setSpecialAchievements(specialData);
        setLoading(false);
      })
      .catch(e => {
        setError(e.message || "Unknown error");
        setLoading(false);
      });
  }, []);

  if (loading)
    return (
      <section id="detail" className="parallax-section">
        <div className="container">
          <div className="row">
            <div
              className="wow fadeInLeft col-md-6 col-sm-6"
              data-wow-delay="0.3s"
            >
              <h3>Latest Information</h3>
              <div>Loading...</div>
            </div>
            <div
              className="wow fadeInRight col-md-6 col-sm-6"
              data-wow-delay="0.6s"
            >
              <h3>Special Achievements</h3>
              <div>Loading...</div>
            </div>
          </div>
        </div>
      </section>
    );

  if (error)
    return (
      <section id="detail" className="parallax-section">
        <div className="container">
          <div className="row">
            <div
              className="wow fadeInLeft col-md-6 col-sm-6"
              data-wow-delay="0.3s"
            >
              <h3>Latest Information</h3>
              <div style={{ color: "red" }}>{error}</div>
            </div>
            <div
              className="wow fadeInRight col-md-6 col-sm-6"
              data-wow-delay="0.6s"
            >
              <h3>Special Achievements</h3>
              <div style={{ color: "red" }}>{error}</div>
            </div>
          </div>
        </div>
      </section>
    );

  return (
    <section id="detail" className="parallax-section">
      <div className="container">
        <div className="row">
          <div
            className="wow fadeInLeft col-md-6 col-sm-6"
            data-wow-delay="0.3s"
          >
            <i
              className="fa fa-info-circle"
              style={{ fontSize: 48, color: "#337ab7" }}
            ></i>
            <h3>Latest Information</h3>
            <ul style={{ listStyleType: "disc", paddingLeft: 20, textAlign: "left" }}>
              {latestInfo.length === 0 && <li>No information available.</li>}
              {latestInfo.map((info, i) => (
                <li key={i}>
                  {info.pathUrl ? (
                    <a href={info.pathUrl} target="_blank" rel="noopener noreferrer">
                      {info.remark}
                    </a>
                  ) : (
                    info.remark
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div
            className="wow fadeInRight col-md-6 col-sm-6"
            data-wow-delay="0.6s"
          >
            <i
              className="fa fa-trophy"
              style={{ fontSize: 48, color: "#f39c12" }}
            ></i>
            <h3>Special Achievements</h3>
            <ul style={{ listStyleType: "disc", paddingLeft: 20, textAlign: "left" }}>
              {specialAchievements.length === 0 && <li>No special achievements yet.</li>}
              {specialAchievements.map((a, i) => (
                <li key={i}>{a.description}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
